import React from "react";
import { formatCurrency } from "utils";
import { useQuery } from "@apollo/react-hooks";
import { GET_ISSUING_BALANCES_QUERY } from "../gql";

export const IssuingApprovedBalance = () => {
  const { data, loading } = useQuery(GET_ISSUING_BALANCES_QUERY);
  const available = (data?.getIssuingBalances?.available || 0) / 100;
  return (
    <div
      className="w-full px-4 py-2 shadow flex flex-col items-center"
      style={{ minWidth: 240 }}
    >
      <p className="font-bold mr-1 text-xl">Spending Power</p>
      <div className="flex flex-col h-full justify-center">
        {loading ? (
          <i className="ml-2 fas fa-circle-notch fa-spin" />
        ) : (
          <div className="text-3xl">{formatCurrency(available)}</div>
        )}
      </div>
    </div>
  );
};
